@if (isModalVisible) {
  <div class="overlay">
    <div class="panel" (click)="$event.stopPropagation()">

      <!-- Header -->
      <div class="p-head">
        <div class="p-badge"><i class="fas fa-trash-alt"></i></div>
        <div class="p-titles">
          <h2>{{ 'remove-form-popup.title' | translate }}</h2>
          <p>{{ 'remove-form-popup.text' | translate }}</p>
        </div>
        <button type="button" class="p-close" (click)="onClickDelete(false)">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- Body -->
      <div class="p-body">

        <!-- Irreversible warning -->
        <div class="warn">
          <i class="fas fa-triangle-exclamation"></i>
          <span>{{ 'remove-form-popup.warning' | translate }}</span>
        </div>

        <!-- Type-to-confirm -->
        <p class="confirm-hint">{{ 'remove-form-popup.input.subtext.part1' | translate }}</p>

        <copy-chip [value]="_formObject?.name ?? ''"/>

        <form [formGroup]="form">
          <form-input controlName="name" label="remove-form-popup.input.name"/>
        </form>
      </div>

      <!-- Footer -->
      <div class="p-foot">
        <button type="button" class="btn-ghost" (click)="onClickDelete(false)">
          {{ 'remove-form-popup.button.cancel' | translate }}
        </button>
        <button type="button" class="btn-danger" [disabled]="!onValidateEnable()" (click)="onClickDelete(true)">
          <i class="fas fa-trash-alt"></i>
          {{ 'remove-form-popup.button.delete-form' | translate }}
        </button>
      </div>

    </div>
  </div>
}